import styled, { css } from 'styled-components';
// import img from '/passenger/images/static/card-template.svg';
export const Wrapper = styled.div<{ $bgColor: string }>`
  border-radius: ${({ theme }) => theme.rounded.x4};
  width: 284px;
  height: 183px;
  ${({ $bgColor }) =>
    $bgColor
      ? css`
          background: ${$bgColor};
        `
      : 'transparent'}
`;
